module.exports = __webpack_public_path__ + "static/0020-3e105175c033ab24d6820591d221daa7.png";